import Header from "../../../../components/header";

const AdminManagePartisanChartHeader = () => {
  return (
    <>
      <Header>
        <div className="container w-full mx-auto">
          <div className="container h-[80px] mx-auto text-3xl text-white font-semibold flex items-center">
            Create Partisan Primary Election Test Chart
          </div>
        </div>
      </Header>
    </>
  );
};

export default AdminManagePartisanChartHeader;
